import React, { Component } from "react";
import compareDesc from "date-fns/compareDesc";

import ScrollView from "sub_components/Common/BloxScrollViewNew";
import { ReleaseApi } from "services/release";
import { TicketApi } from "services/ticket";
import { Utils } from "services/utils";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const unviewedDefaultDownloadCloud = `${CDN_URL}common/download-cloud-icon-default-unviewed.svg`;
const unviewedHoverDownloadCloud = `${CDN_URL}common/download-cloud-icon-hover-unviewed.svg`;

const viewedDefaultDownloadCloud = `${CDN_URL}common/download-cloud-icon-default-lg.svg`;
const viewedHoverDownloadCloud = `${CDN_URL}common/download-cloud-icon-hover-lg.svg`;

const downArrowDefault = `${CDN_URL}common/down-nav-triangle-default-lg.svg`;
const upArrowDefault = `${CDN_URL}common/up-nav-triangle-default-lg.svg`;
const downArrowHover = `${CDN_URL}common/down-nav-triangle-hover-lg.svg`;
const upArrowHover = `${CDN_URL}common/up-nav-triangle-hover-lg.svg`;
const downArrowSelected = `${CDN_URL}common/down-nav-triangle-selected-lg.svg`;
const upArrowSelected = `${CDN_URL}common/up-nav-triangle-selected-lg.svg`;

const downloadCloudProfile = `${CDN_URL}common/download-cloud-icon-profile-lg.svg`;
const downloadCloudBilling = `${CDN_URL}common/download-cloud-icon-billing-lg.svg`;
const downloadCloudSupport = `${CDN_URL}common/download-cloud-icon-support-lg.svg`;
const downloadCloudStorage = `${CDN_URL}common/download-cloud-icon-storage-lg.svg`;
const downloadCloudColocation = `${CDN_URL}common/download-cloud-icon-colocation-lg.svg`;

class ListView extends Component {
  constructor(props) {
    super(props);

    this.releaseApi = new ReleaseApi();
    this.state = {
      upArrow: null,
      downArrow: null,
    };
  }
  componentDidMount() {
    this.getArrows();
  }
  getArrows = (state, direction) => {
    switch (state) {
      case "HOVER":
        if (direction === "UP") {
          this.setState({ upArrow: upArrowHover });
        } else {
          this.setState({ downArrow: downArrowHover });
        }
        break;
      case "SELECTED":
        if (direction === "UP") {
          this.setState({ upArrow: upArrowSelected });
        } else {
          this.setState({ downArrow: downArrowSelected });
        }

        break;
      default:
        this.setState({ upArrow: upArrowDefault, downArrow: downArrowDefault });
        break;
    }
  };

  changeToHoverIcon = (release) => {
    const currentElementsClassList = document.getElementById(
      `download-button-wrapper${release.version}`
    ).classList;
    if (!currentElementsClassList.contains("selected") && !release.viewed) {
      document.getElementById(`download-button-${release.version}`).src =
        unviewedHoverDownloadCloud;
    }
    if (!currentElementsClassList.contains("selected") && release.viewed) {
      document.getElementById(`download-button-${release.version}`).src =
        viewedHoverDownloadCloud;
    }
  };
  changeToDefaultIcon = (release) => {
    const currentElementsClassList = document.getElementById(
      `download-button-wrapper${release.version}`
    ).classList;
    if (!currentElementsClassList.contains("selected") && !release.viewed) {
      document.getElementById(`download-button-${release.version}`).src =
        unviewedDefaultDownloadCloud;
    }
    if (!currentElementsClassList.contains("selected") && release.viewed) {
      document.getElementById(`download-button-${release.version}`).src =
        viewedDefaultDownloadCloud;
    }
  };
  changeToSelectedIcon = (id) => {
    const { site } = this.props;
    let selectedIcon = "";

    switch (site.module) {
      case "BILLING":
        selectedIcon = downloadCloudBilling;
        break;
      case "STORAGE":
        selectedIcon = downloadCloudStorage;
        break;
      case "SUPPORT":
        selectedIcon = downloadCloudSupport;
        break;
      case "ACCOUNT":
        selectedIcon = downloadCloudProfile;
        break;
      case "COLO":
        selectedIcon = downloadCloudColocation;
        break;
      default:
        selectedIcon = downloadCloudProfile;
        break;
    }

    document.getElementById(`download-button-${id}`).src = selectedIcon;
    document
      .getElementById(`download-button-wrapper${id}`)
      .classList.add("selected");
  };

  downloadPdf = (release) => {
    if (!release.viewed) {
      this.updateReleaseToViewed(release.release_id);
    }
    this.changeToSelectedIcon(release.version);
  };
  setParams = (release) => {
    const { updatePage } = this.props;
    updatePage("DETAIL_VIEW", {
      name: release.version,
      date: release.publish_date,
    });
    if (!release.viewed) {
      this.updateReleaseToViewed(release.release_id);
    }
  };
  updateReleaseToViewed = (release_id) => {
    const { auth_status } = this.props;
    const {
      user: { id },
    } = auth_status;
    const params = { userId: id, releaseId: release_id };

    return this.releaseApi
      .updateReleaseToViewed(params)
      .then((response) => {
        if (!Utils.isValidResponse(response)) {
          this.setState({ error: response.data.error });
        }
      })
      .catch((error) => this.setState({ error }));
  };

  createContent = (releases) => {
    return releases.map((release) => {
      const version = release.version.split(" ").join("");

      return (
        <div
          className={release.viewed ? "sprint viewed" : "sprint"}
          key={release.version}
        >
          <div className="release-info" onClick={() => this.setParams(release)}>
            {release.version}
          </div>
          <div className="date" onClick={() => this.setParams(release)}>
            {TicketApi.getFormattedMonthDayYear(release.publish_date)}
          </div>
          <div
            className="download-button"
            onMouseOver={() => this.changeToHoverIcon(release)}
            onMouseOut={() => this.changeToDefaultIcon(release)}
            onClick={() => this.downloadPdf(release)}
            id={`download-button-wrapper${release.version}`}
          >
            <a
              href={`/cdn/release/${version}.pdf`}
              download={`${version}.pdf`}
              aria-label={`${version}.pdf`}
            >
              <img
                id={`download-button-${release.version}`}
                src={
                  release.viewed
                    ? viewedDefaultDownloadCloud
                    : unviewedDefaultDownloadCloud
                }
              />
            </a>
          </div>
        </div>
      );
    });
  };
  setActiveScrollbar = () => {
    const scrollbar = document.querySelector(".ScrollbarsCustom");
    if (scrollbar) {
      this.setState({ scrollActive: true });
    }
  };
  removeActiveScrollbar = () => {
    const scrollbar = document.querySelector(".ScrollbarsCustom");
    if (scrollbar) {
      this.setState({ scrollActive: false });
    }
  };
  sortReleases = (releases, year) => {
    let sortedReleases = releases;
    sortedReleases = sortedReleases.sort((a, b) =>
      compareDesc(new Date(a.publish_date), new Date(b.publish_date))
    );
    if (year === "latest") {
      return sortedReleases.slice(0, 6);
    } else {
      return sortedReleases.slice(6, sortedReleases.length);
    }
  };

  render() {
    const { onScrollStop, scrollTop, releases, year, site } = this.props;
    const { scrollActive } = this.state;
    const sortedReleases = this.sortReleases(releases, year);

    return (
      <>
        <div className="content-header">
          <div className="release-number footer31">RELEASE #</div>
          <div className="download footer31">DOWNLOAD</div>
        </div>
        <ScrollView
          module={scrollActive ? site.module : ""}
          scrollTop={scrollTop}
          onScrollStop={onScrollStop}
          onHoverOver={this.setActiveScrollbar}
          onHoverOut={this.removeActiveScrollbar}
        >
          <div className="release-list-wrapper">
            <div className="release-list">
              {sortedReleases &&
                sortedReleases.length !== 0 &&
                this.createContent(sortedReleases)}
            </div>
          </div>
        </ScrollView>
      </>
    );
  }
}

export default ListView;
